<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 1200px;">
      <header class="modal-card-head">
        <p class="modal-card-title">Conciliation Process</p>
      </header>
      <section class="modal-card-body">
        <div class="content" v-if="conciliation_imports_process">
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th>Line</th>
                <th>Service</th>
                <th>Payment</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="conciliation in conciliation_imports_process">
                <td>{{ conciliation.line }}</td>
                <td>{{ conciliation.service }}</td>
                <td>{{ conciliation.payment_id }}</td>
                <td>{{ conciliation.message }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-warning" @click="xls">Export XLS</a>
            <a class="button is-primary" @click="close(false)">Cancel</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import message from '../../../../utils/message'
  // import Payment from '../finances/payment'
  import Tooltip from 'vue-bulma-tooltip'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      id: {
        type: Number
      }
    },
    data () {
      return {
        conciliation_imports_process: null,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/V2/payment/conciliation_process/' + this.id).then((response) => {
          this.conciliation_imports_process = response.body
          if (response.body === '') {
            this.close(false)
          } else {
            document.body.appendChild(this.$el)
          }
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      xls () {
        window.location.href = this.context.$store.state.config.apiURL + '/V2/payment/conciliation/xls/' + this.id
      },
      handleFileUploadCSV () {
        let ext = this.$refs.conciliation_file.files[0].type
        if ((ext !== 'text/csv') && (ext !== 'application/vnd.ms-excel')) {
          this.file = null
          this.$refs.conciliation_file.value = ''
          this.error = 'Select a CSV file!'
        } else {
          this.file = this.$refs.conciliation_file.files[0]
          this.error = ''
        }
      },
      async submitConciliationFileCSV () {
        if (this.file !== null) {
          let data = new window.FormData()
          data.append('file', this.file)
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/files/conciliation', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            this.loadData()
            let propsData = {
              title: 'Upload',
              message: 'Conciliation file updoad successful',
              type: 'success',
              direction: 'down',
              duration: 4500,
              showCloseButton: true
            }
            message.openMessage(propsData)
            this.file = null
            this.$refs.conciliation_file.value = ''
          }, (response) => {
            this.loadData()
          })
        } else {
          return true
        }
      },
      close (closeOnly, result) {
        if ((!closeOnly) && (typeof this.context[this.callback] === 'function')) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      parseDate (content) {
        return this.$moment(content).format('YYYY-MM-DD')
      },
      parseStatus (content) {
        switch (parseInt(content)) {
          case 0:
            return 'Unprocessed'
          case 1:
            return 'Processed'
          case 2:
            return 'File Error'
          case 3:
            return 'Verification Required'
        }
      }
    },
    components: {
      Tooltip
    }
  }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// PaymentConciliationProcess.vue?c73a175c